import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { SiteServices } from '../../services/siteservices';
import { PaginationModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AlertModule } from 'ngx-bootstrap/alert';
import { RouteReuseStrategy } from '@angular/router';
import { CATEGORYBLOCK_ROUTER_PROVIDERS } from './categoryblock.routes';

import { CustomReuseStrategy } from '../common/route.reuse';

//import { ProductListComponent } from './productlist.main';
import { CategoryBlockList } from './categoryblock.list';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { HttpClientModule } from '@angular/common/http';
import { CategoryBlockComponent } from './categoryblock.main';
import { CategoryBlockDetailFrm } from './categoryblock.frm';
import { FileUploadModule } from 'ng2-file-upload';

import { DecimalOnlyDirective } from '../../directives/decimalonly.directive';
import { IntegerOnlyDirective } from '../../directives/integeronly.directive';
import { CurrencyOnlyDirective } from '../../directives/currencyonly.directive';

import { ColorPickerModule } from 'ngx-color-picker';

import { Ng2SearchPipeModule } from 'ng2-search-filter';

import {
    LazyLoadImageModule,
    intersectionObserverPreset,
} from 'ng-lazyload-image';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { ModalDialogModule } from 'ngx-modal-dialog';

@NgModule({
    declarations: [
        CategoryBlockList,
        CategoryBlockComponent,
        CategoryBlockDetailFrm,
        DecimalOnlyDirective,
        IntegerOnlyDirective,
        CurrencyOnlyDirective,
    ],
    imports: [
        BrowserModule,
        CATEGORYBLOCK_ROUTER_PROVIDERS,
        FormsModule,
        HttpModule,
        HttpClientModule,
        DragDropModule,
        PaginationModule.forRoot(),
        AlertModule.forRoot(),
        ModalModule.forRoot(),
        ModalDialogModule.forRoot(),
        TabsModule.forRoot(),
        FileUploadModule,
        Ng2SearchPipeModule,
        ColorPickerModule,
        LazyLoadImageModule.forRoot({
            preset: intersectionObserverPreset, // <-- tell LazyLoadImage that you want to use IntersectionObserver
        }),

        MDBBootstrapModule.forRoot(),
    ],
    providers: [
        SiteServices,
        { provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
    ],
    bootstrap: [CategoryBlockComponent],
})
export class CategoryBlockModule {}
